import { render, staticRenderFns } from "./compJpLog.vue?vue&type=template&id=2fc84c04"
import script from "./compJpLog.vue?vue&type=script&lang=js"
export * from "./compJpLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports